export const StructureItemActionTypes = {
  API_RESPONSE_SUCCESS: '@@structure-items/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@structure-items/API_RESPONSE_ERROR',

  GET_STRUCTURE_ITEM: '@@structure-items/GET_STRUCTURE_ITEM',
  LIST_STRUCTURE_ITEMS: '@@structure-items/LIST_STRUCTURE_ITEMS',
  ADD_STRUCTURE_ITEM: '@@structure-items/ADD_STRUCTURE_ITEM',
  UPDATE_STRUCTURE_ITEM: '@@structure-items/UPDATE_STRUCTURE_ITEM',
  DELETE_STRUCTURE_ITEM: '@@structure-items/DELETE_STRUCTURE_ITEM',
  SET_FILTER_STRUCTURE_ITEMS: '@@structure-items/SET_FILTER_STRUCTURE_ITEMS',

  RESET: '@@structure-items/RESET'
}
